import React from 'react'
import { Value } from '../../../pages_v2/elements'
import dayjs from 'dayjs'
import { formatPhoneNumber } from '../../../../lib/utils/helpers'
import { Tag } from 'antd'
import { ComplianceListIcons } from './ui/compliance-list-icons'

export interface MobileField {
  key: string
  label: string
  render?: (value: any, record: any) => React.ReactNode
}

export const getMobileFields = (): MobileField[] => [
  {
    key: 'fio',
    label: 'ФИО',
    render: (val, record) => (
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          width: '100%',
        }}
      >
        <span style={{ minWidth: 0, flex: 1 }}>
          <Value data={val} />
        </span>
        <ComplianceListIcons record={record} />
      </span>
    ),
  },
  {
    key: 'phones',
    label: 'Телефон',
    render: (_, record) => {
      const phones = record.phones ?? (record.phone ? [record.phone] : [])
      if (phones.length === 0) return null
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {phones.map((p, i) => (
            <span key={i}>{formatPhoneNumber(p)}</span>
          ))}
        </div>
      )
    },
  },
  {
    key: 'post',
    label: 'Должность',
    render: val => <Value data={val} />,
  },
  {
    key: 'department',
    label: 'Отдел',
    render: val => <Value data={val} />,
  },
  {
    key: 'section_1',
    label: 'Участок 1',
    render: val => <Value data={val} />,
  },
  {
    key: 'section_2',
    label: 'Участок 2',
    render: val => <Value data={val} />,
  },
  {
    key: 'office',
    label: 'Офис',
    render: val => <Value data={val} />,
  },
  {
    key: 'employment_date',
    label: 'Дата приема',
    render: val => (val ? dayjs(val).format('DD.MM.YYYY') : <Value data={val} />),
  },
  {
    key: 'dismissal_date',
    label: 'Дата увольнения',
    render: val => (val ? dayjs(val).format('DD.MM.YYYY') : <Value data={val} />),
  },
  {
    key: 'is_active',
    label: 'Статус',
    render: (val: boolean) => <Tag color={val ? 'green' : 'red'}>{val ? 'Активен' : 'Уволен'}</Tag>,
  },
]
